/* eslint-disable camelcase */
import { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { actions, Control, Errors, Form } from 'forms/rrf';
import { Button, Col, Container, Row } from 'react-bootstrap';
import qs from 'qs';
import BsCheckbox from '../common/form/elements/bs-checkbox';
import PageTitle from '../common/page-title';
import ErrorMessages from '../login/error-messages';
import RequiredPasswordMaskInput from '../common/form/elements/required-password-mask-input';
import UserTitleSelector from '../common/form/user/user-title-selector';
import UserFirstNameInput from '../common/form/user/user-first-name-input';
import UserLastNameInput from '../common/form/user/user-last-name-input';
import DateOfBirthSelector from '../common/form/user/date-of-birth-selector';
import { getInvitationInfo, saveAboutYouOwner, saveAboutYouStaff } from '../../actions/about-you';
import TextViewer from '../common/editor/text-viewer';
import MarketingPreferences from './marketing-preferences';
import CommunicationPreferences from '../common/form/user/communication-preferences';
import CommunicationDetails from '../common/form/user/communication-details';
import IgniteUkLogo from '../../assets/img/ignite_logo_black.png';

import './style.css';

class InformationsAboutYou extends Component {
  constructor(props) {
    super(props);

    this.state = {};

    const { dispatch } = this.props;

    if (props.location.state && props.location.state.doNotKnowCustomerNumber) {
      dispatch({ type: 'RESET_OUTLET_VALIDATION' });
    }

    if (props.location.search) {
      const params = qs.parse(props.location.search.slice(1));

      if (params.invitation_token) {
        this.invitation_token = params.invitation_token;

        dispatch(getInvitationInfo(params.invitation_token));
      }
    }
  }

  onNextClicked = (payload) => {
    const { dispatch, registration } = this.props;
    const { invitation_token } = this;

    if (invitation_token) {
      dispatch(actions.submitFields('deep.about_you.user', saveAboutYouStaff(payload, registration, invitation_token)));
    } else {
      dispatch(actions.submitFields('deep.about_you.user', saveAboutYouOwner(payload, registration)));
    }
  };

  render() {
    const {
      t_cs1, t_cs2, t_cs_champion, formValid, customer_number,
      champion, commsEmail, commsMobile, anyMarketingAccepted
    } = this.props;

    return (
      <Form
        className="register-about-you"
        model="deep.about_you.user"
        onSubmit={this.onNextClicked}
      >
        <Errors
          className="errors"
          component={ErrorMessages}
          model="deep.about_you.user"
        />
        <Container className="user-inner-container">
          <Row>
            <Col lg={12}>
              <img src={IgniteUkLogo} alt="Ignite UK" />
              <PageTitle>
                About you
              </PageTitle>
              <div className="inline-editor">
                <TextViewer pageSlug='about-you' className="editable"/>
              </div>
            </Col>
            <Col lg={6}>
              <UserTitleSelector model="deep.about_you.user.title"/>
              <UserFirstNameInput/>
              <UserLastNameInput/>
              <DateOfBirthSelector/>
              <CommunicationDetails/>
              <div className="marketing-preferences">
                <MarketingPreferences
                  title={(
                    <div className="marketing-label">Marketing preferences*</div>
                  )}
                  customer_number={customer_number}
                  invitation={this.invitation_token}
                />
              </div>
              {anyMarketingAccepted && (
                <CommunicationPreferences
                  commsEmail={commsEmail}
                  commsMobile={commsMobile}
                  model={'deep.about_you.user'}
                  marketing
                />
              )}
            </Col>
            <Col lg={6}>
              <div className="password-label">
                Password
              </div>
              <RequiredPasswordMaskInput
                controlId="newPassword"
                label="The password must be a minimum of 8 characters and contain one uppercase, one
              lowercase, and one number."
                model=".password"
              />
              <RequiredPasswordMaskInput
                controlId="passwordConfirm"
                label="Confirm Password"
                model=".password_confirmation"
              />
              <Control.checkbox component={BsCheckbox} className="terms" model=".t_cs1">
                I have read and understand the programme
                {' '}
                <Link
                  target="_blank"
                  to="/content-pages/terms-conditions"
                  className="link"
                >
                  terms & conditions
                </Link>
                .
              </Control.checkbox>
              {champion && (
                <Control.checkbox component={BsCheckbox} className="terms" model=".t_cs_champion">
                  I agree to the champion staff terms and conditions.
                  {' '}
                  <Link
                    target="_blank"
                    to="/content-pages/champion-terms-conditions"
                    className="link"
                  >
                    Read here
                  </Link>
                  .
                </Control.checkbox>
              )
              }
              <p className="font-size-14">
                Click{' '}
                <a className="link" href="/content-pages/privacy-policy" target="_blank">
                  here{' '}
                </a>
                to view the programme
                privacy policy and learn more about how we will use your data
              </p>
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <Button
                variant="primary"
                className="red-btn float-right"
                disabled={!t_cs1 || !t_cs2 || !formValid || (champion && !t_cs_champion)}
                type="submit"
              >
                Next
              </Button>
            </Col>
          </Row>
        </Container>
      </Form>
    );
  }
}

const mapStateToProps = state => ({
  eircode: state.aboutYou.outlet.eircode,
  passcode: state.aboutYou.outlet.passcode,
  customer_number: state.aboutYou.outlet.customer_number,
  champion: state.deep.about_you.user.champion,
  t_cs1: state.deep.about_you.user.t_cs1,
  t_cs2: state.deep.about_you.user.t_cs2,
  t_cs3: state.deep.about_you.user.t_cs3,
  t_cs_champion: state.deep.about_you.user.t_cs_champion,
  marketing: state.deep.about_you.user.marketing,
  anyMarketingAccepted: state.deep.about_you.user.marketing_categories ?
    Object.values(state.deep.about_you.user.marketing_categories).some(element => element.value) : false,
  commsEmail: !!state.deep.about_you.user.comms_email,
  commsMobile: !!state.deep.about_you.user.comms_mobile,
  registration: state.registration,
  form: state.deep.forms.about_you.user,
  formValid: state.deep.forms.about_you.user.$form.valid,
});

export default connect(mapStateToProps)(InformationsAboutYou);
